export default __webpack_public_path__ + "static/media/lep-gif-5.f09f7edc.gif";